module.exports = __webpack_public_path__ + "img/chemistry.9d943671.svg";